import { render } from "./employee-and-additional-driver.vue?vue&type=template&id=0e36229a"
import script from "./employee-and-additional-driver.vue?vue&type=script&lang=js"
export * from "./employee-and-additional-driver.vue?vue&type=script&lang=js"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__